<template>
  <v-main>
    <v-container fluid class="d-flex justify-center">
      <v-card elevation="0" width="800px">
        <v-card-title>Settings page</v-card-title>
        <v-container>
          <v-card-text>
            <v-col xl="6" lg="6" md="6" sm="12" cols="12">
              <v-autocomplete class="role-autocomplete" v-model="admincompanyId" :items="companies"
                placeholder="Select a company" solo dense></v-autocomplete>
            </v-col>
            <v-col cols="12" class="pb-5">
              <vs-button class="float-end px-6" color="#6c5dd4" dark :loading="isLoading" width="200"
                @click="selectedOrganization">
                Update
              </vs-button>
            </v-col>
          </v-card-text>
        </v-container>
      </v-card>
      <vs-dialog width="550px" not-center v-model="dialog">
        <template #header>
          <h4 class="not-margin">Welcome to <b>AZRMS</b></h4>
        </template>

        <div class="con-content">
          <p>
            Company selected. Now you have access to the users, admins, units,
            and reports. You can also export them.
          </p>
        </div>
        <template #footer>
          <div class="con-footer">
            <vs-button @click="dialog = false" transparent> Ok </vs-button>
          </div>
        </template>
      </vs-dialog>
      <vs-dialog width="550px" not-center v-model="warningdialog">
        <template #header>
          <h4 class="not-margin">Welcome to <b>AZRMS</b></h4>
        </template>

        <div class="con-content">
          <p>
            Please Select any company to get access for users and units section other wise you will not able to access
            it.
          </p>
        </div>

        <template #footer>
          <div class="con-footer">
            <vs-button @click="warningdialog = false" transparent> Ok </vs-button>
          </div>
        </template>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  data() {
    return {
      companies: [],
      admincompanyId: null,
      isLoading: false,
      dialog: false,
      warningdialog: false,
      value: '',

    };
  },
  mounted() {
    this.admincompanyId = this.$store.getters["settings/getCompanyId"];
    this.getData();
  },
  methods: {
    async getData() {
      let companies = await axios.get(`companies`);
      companies.data.data.forEach((company) => {
        this.companies.push({
          id: company.id,
          text: company.name,
          value: company.id,
        });
      });
    },
    async selectedOrganization() {
      this.isLoading = true;
      if (this.admincompanyId == null) {
        this.warningdialog = true;
      } else {
        await store.dispatch("settings/setCompayId", this.admincompanyId);
      }
      this.dialog = true;
      this.isLoading = false;
    },
  },
};
</script>
<style>
.v-parallax__content {
  justify-content: flex-start !important;
  padding: 0px !important;
}
</style>
